import {
  faChevronDown,
  faChevronRight,
  faCircleNotch,
  faEye,
  faEyeSlash,
  faVectorSquare,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Collapse, Grid } from '@mui/material';
import StyledButton from 'components/general/StyledButton';
import { useState } from 'react';
import theme from 'theme';
import { TargetVables } from 'utils/vable';
import useStyles from './styles';

const MenuRow = (props) => {
  const { label, buttonProps } = props;
  const { classes, cx } = useStyles();
  return (
    <Grid container spacing={0} alignItems="center" justifyContent="center">
      <Grid item xs={buttonProps ? 12 - 2 * buttonProps.length : 12}>
        {typeof label === 'string' ? <h6>{label}</h6> : label}
      </Grid>
      {buttonProps &&
        buttonProps.map((_props, index) => {
          const { type, icon, className, ...rest } = _props;
          return (
            <Grid item xs={2} key={index}>
              {type === 'icon' ? (
                // <IconButton className={cx(className, classes.expandButton)} {...rest}>
                //   <FontAwesomeIcon icon={icon} />
                // </IconButton>
                <StyledButton
                  className={cx(className, classes.expandButton)}
                  type="button"
                  dontDisableInReadOnly
                  disableInteractive
                  min
                  framed
                  {...rest}
                >
                  <FontAwesomeIcon icon={icon} />
                </StyledButton>
              ) : (
                <StyledButton
                  className={cx(className, classes.viewerButton)}
                  type="button"
                  dontDisableInReadOnly
                  disableInteractive
                  min
                  {...rest}
                >
                  <FontAwesomeIcon icon={icon} />
                </StyledButton>
              )}
            </Grid>
          );
        })}
    </Grid>
  );
};

export const TargetFilterMenu = (props) => {
  const { target, entityFilter, setEntityFilter, ...remainingProps } = props;
  const [filterMenuExpanded, setFilterMenuExpanded] = useState(new Set());

  return (
    <div style={{ paddingLeft: 20, width: '100%' }} {...remainingProps}>
      {target.fovs?.length > 0 && (
        <div>
          <MenuRow
            label="Fields of View"
            buttonProps={[
              ...(target.fovs.some((v) => v.viewshed)
                ? [
                    {
                      onClick: () => {
                        const off = target.fovs.some(
                          (v) => !entityFilter[target.name][v.name + '-viewshed']
                        );
                        setEntityFilter({
                          ...entityFilter,
                          [target.name]: {
                            ...entityFilter[target.name],
                            ...target.fovs.reduce((acc, { name }) => {
                              acc[name + '-viewshed'] = off;
                              return acc;
                            }, {}),
                          },
                        });
                      },
                      off: target.fovs.some(
                        (v) => !entityFilter[target.name][v.name + '-viewshed']
                      ),
                      tooltip: target.fovs.some(
                        (v) => !entityFilter[target.name][v.name + '-viewshed']
                      )
                        ? 'Show all viewsheds'
                        : 'Hide all viewsheds',
                      icon: faVectorSquare,
                    },
                  ]
                : []),
              {
                onClick: () => {
                  const off = target.fovs.some((v) => !entityFilter[target.name][v.name]);
                  setEntityFilter({
                    ...entityFilter,
                    [target.name]: {
                      ...entityFilter[target.name],
                      ...target.fovs.reduce((acc, { name }) => {
                        acc[name] = off;
                        return acc;
                      }, {}),
                    },
                  });
                },
                off: target.fovs.some((v) => !entityFilter[target.name][v.name]),
                tooltip: target.fovs.some((v) => !entityFilter[target.name][v.name])
                  ? 'Show all fields of view'
                  : 'Hide all fields of view',
                icon: entityFilter[target.name] ? faEye : faEyeSlash,
              },
              {
                type: 'icon',
                onClick: () =>
                  setFilterMenuExpanded((prev) => {
                    prev.has('FOV') ? prev.delete('FOV') : prev.add('FOV');
                    return new Set(prev);
                  }),
                icon: filterMenuExpanded.has('FOV') ? faChevronDown : faChevronRight,
              },
            ]}
          />
          <Collapse in={filterMenuExpanded.has('FOV')}>
            <div style={{ paddingLeft: 20, width: '100%' }}>
              {target.fovs.map(({ name, viewshed }) => {
                return (
                  <MenuRow
                    key={name}
                    label={name}
                    buttonProps={[
                      ...(viewshed
                        ? [
                            {
                              onClick: () => {
                                setEntityFilter({
                                  ...entityFilter,
                                  [target.name]: {
                                    ...entityFilter[target.name],
                                    [name + '-viewshed']:
                                      !entityFilter[target.name][name + '-viewshed'],
                                  },
                                });
                              },
                              off: !entityFilter[target.name][name + '-viewshed'],
                              tooltip: entityFilter[target.name][name + '-viewshed']
                                ? 'Hide viewshed'
                                : 'Show viewshed',
                              icon: faVectorSquare,
                            },
                          ]
                        : []),
                      {
                        onClick: () => {
                          setEntityFilter({
                            ...entityFilter,
                            [target.name]: {
                              ...entityFilter[target.name],
                              [name]: !entityFilter[target.name][name],
                            },
                          });
                        },
                        off: !entityFilter[target.name][name],
                        tooltip: entityFilter[target.name][name]
                          ? 'Hide field of view'
                          : 'Show field of view',
                        icon: entityFilter[target.name][name] ? faEye : faEyeSlash,
                      },
                    ]}
                  />
                );
              })}
            </div>
          </Collapse>
        </div>
      )}
      {target.bfVectors?.length > 0 && (
        <div>
          <MenuRow
            label="Body Frame Vectors"
            buttonProps={[
              {
                onClick: () => {
                  const off = target.bfVectors.some((v) => !entityFilter[target.name][v.name]);
                  setEntityFilter({
                    ...entityFilter,
                    [target.name]: {
                      ...entityFilter[target.name],
                      ...target.bfVectors.reduce((acc, { name }) => {
                        acc[name] = off;
                        return acc;
                      }, {}),
                    },
                  });
                },
                off: target.bfVectors.some((v) => !entityFilter[target.name][v.name]),
                tooltip: target.bfVectors.some((v) => !entityFilter[target.name][v.name])
                  ? 'Show all body frame vectors'
                  : 'Hide all body frame vectors',
                icon: entityFilter[target.name] ? faEye : faEyeSlash,
              },
              {
                type: 'icon',
                onClick: () =>
                  setFilterMenuExpanded((prev) => {
                    prev.has('BFV') ? prev.delete('BFV') : prev.add('BFV');
                    return new Set(prev);
                  }),
                icon: filterMenuExpanded.has('BFV') ? faChevronDown : faChevronRight,
              },
            ]}
          />
          <Collapse in={filterMenuExpanded.has('BFV')}>
            <div style={{ paddingLeft: 20, width: '100%' }}>
              {target.bfVectors.map(({ name }) => {
                return (
                  <MenuRow
                    key={name}
                    label={name}
                    buttonProps={[
                      {
                        onClick: () => {
                          setEntityFilter({
                            ...entityFilter,
                            [target.name]: {
                              ...entityFilter[target.name],
                              [name]: !entityFilter[target.name][name],
                            },
                          });
                        },
                        off: !entityFilter[target.name][name],
                        tooltip: entityFilter[target.name][name]
                          ? 'Hide body frame vector'
                          : 'Show body frame vector',
                        icon: entityFilter[target.name][name] ? faEye : faEyeSlash,
                      },
                    ]}
                  />
                );
              })}
            </div>
          </Collapse>
        </div>
      )}
    </div>
  );
};

const targetPriority = (target) => {
  if (target.agentId) {
    if (target.type === TargetVables.Type.SpaceTarget.value) return 0;
    else return 1;
  }
  if (target.type === TargetVables.Type.SpaceTarget.value) return 2;
  if (target.type === TargetVables.Type.GroundTarget.value) return 3;
  if (target.type === TargetVables.Type.AreaTarget.value) return 4;
  if (target.type === TargetVables.Type.CelestialTarget.value) return 5;
  return 10;
};

const FilterMenu = ({ cesiumData, entityFilter, setEntityFilter, warning }) => {
  const [filterMenuExpanded, setFilterMenuExpanded] = useState(new Set());
  const { classes } = useStyles();

  return (
    <div className={classes.filterMenu}>
      {warning && (
        <div
          style={{
            maxWidth: 275,
            border: '1px solid ' + theme.palette.warning.main,
            borderRadius: 4,
            padding: 5,
            textAlign: 'center',
          }}
        >
          <h6>{warning}</h6>
        </div>
      )}

      {cesiumData.targets
        .filter((t) => entityFilter[t.name] && Object.keys(entityFilter[t.name]).length)
        .sort((a, b) => targetPriority(a) - targetPriority(b))
        .map((target) => {
          return (
            <div key={target.name} style={{ padding: 5 }}>
              <MenuRow
                label={<h5>{target.name}</h5>}
                buttonProps={[
                  ...(target.type === TargetVables.Type.SpaceTarget.value
                    ? [
                        {
                          onClick: () => {
                            const off = !entityFilter[target.name].orbit;
                            setEntityFilter({
                              ...entityFilter,
                              [target.name]: {
                                ...entityFilter[target.name],
                                orbit: off,
                              },
                            });
                          },
                          off: !entityFilter[target.name].orbit,
                          tooltip: entityFilter[target.name].orbit
                            ? 'Hide orbit tail'
                            : 'Show orbit tail',
                          icon: faCircleNotch,
                        },
                      ]
                    : []),
                  ...(target.fovs?.length || target.bfVectors?.length
                    ? [
                        {
                          onClick: () => {
                            const off =
                              target.fovs.some((v) => !entityFilter[target.name][v.name]) ||
                              target.bfVectors.some((v) => !entityFilter[target.name][v.name]);
                            setEntityFilter({
                              ...entityFilter,
                              [target.name]: {
                                ...target.fovs.reduce((acc, { name }) => {
                                  acc[name] = off;
                                  return acc;
                                }, {}),
                                ...target.bfVectors.reduce((acc, { name }) => {
                                  acc[name] = off;
                                  return acc;
                                }, {}),
                              },
                            });
                          },
                          off:
                            (target.fovs &&
                              target.fovs.some((v) => !entityFilter[target.name][v.name])) ||
                            (target.bfVectors &&
                              target.bfVectors.some((v) => !entityFilter[target.name][v.name])),
                          tooltip: entityFilter[target.name]
                            ? 'Hide fields of view and body frame vectors'
                            : 'Show fields of view and body frame vectors',
                          icon: entityFilter[target.name] ? faEye : faEyeSlash,
                        },

                        {
                          type: 'icon',
                          onClick: () =>
                            setFilterMenuExpanded((prev) => {
                              prev.has(target.name)
                                ? prev.delete(target.name)
                                : prev.add(target.name);
                              return new Set(prev);
                            }),
                          icon: filterMenuExpanded.has(target.name)
                            ? faChevronDown
                            : faChevronRight,
                        },
                      ]
                    : []),
                ]}
              />
              <Collapse in={filterMenuExpanded.has(target.name)}>
                <TargetFilterMenu
                  key={target.name}
                  target={target}
                  entityFilter={entityFilter}
                  setEntityFilter={setEntityFilter}
                />
              </Collapse>
            </div>
          );
        })}
    </div>
  );
};
export default FilterMenu;
